export function splitInTwo(text: string): [string, string] {
  const words = text.trim().split(/\s+/);
  const half = Math.ceil(words.length / 2);

  const firstPart = words.slice(0, half).join(" ");
  const secondPart = words.slice(half).join(" ");

  return [firstPart, secondPart];
}
